module.exports = __webpack_public_path__ + "static/media/height.ff0a18ee.svg";